$ = jQuery; // in case of no-conflict jquery

carbonhound.site = new carbonhound.CarbonHoundSite({ // config data
  cartDataBaseURL: 'https://carbonhoundusa.com/',
  slowCartAjax: false,
  fakeCartAjax: false,
  cartAjaxEnabled: true
});

// on page loaded
$(function() {
  carbonhound.site.init();
});